module.exports = "<!--周选择-->\n<input week-picker week-data=\"weekData1\"> \n{{weekData1|json}}\n";